import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';
import { tableStyles } from '../../../theme/AllocateBaseTheme';
import { addDaysToDate } from '../../../utils/datetimeconverter';

export default class DefaultTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCheckboxes: false,
      date: new Date(),
    };
  }

  generateHeaderRows = date => {
    const headers = [];
    headers.push(<TableHeaderColumn key={0} className="fixed-header" />);
    for (let col = -6; col < 8; col += 1) {
      const newDate = addDaysToDate(date, col);
      const key = col + 1;
      headers.push(
        <TableHeaderColumn key={key} className="data-header">
          {moment(newDate).format('MMM Do')}
        </TableHeaderColumn>,
      );
    }
    return headers;
  };

  render() {
    return (
      <div>
        <Table headerStyle={tableStyles.headerStyle}>
          <TableHeader displaySelectAll={this.state.showCheckboxes} className="table-header">
            <TableRow className="header-row">{this.generateHeaderRows(this.props.date)}</TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={this.state.showCheckboxes} className="table-content" />
        </Table>
      </div>
    );
  }
}

DefaultTable.propTypes = {
  date: PropTypes.shape(Date).isRequired,
};
